export default {"src":"/_next/static/media/instagram.5171b6e8.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};